import { Platform } from 'react-native';

import { ICRMEventsContext } from 'state/crm-events';
import { EventTypes } from 'state/crm-events/constants';
import logger from 'utils/logger';
import {
  appTrackingTransparency,
  enableLocation,
  enablePush,
  openPushSetting,
} from 'utils/permissions';
import { promptReview } from 'utils/review/prompt-review';

export enum OsPrompts {
  push = 'push',
  location = 'location',
  review = 'review',
  att = 'att',
  pushSetting = 'pushSetting',
}

// checkForOSPrompts checks a URL for a `/OS/*`
// return true if /OS/ link
export const checkForOSPrompts = (
  url: string,
  logRBIEvent?: ICRMEventsContext['logRBIEvent']
): boolean => {
  // If the link is /OS/* then prompt
  const [, maybeOS = '', maybeAction = ''] = url.split('/');

  if (maybeOS !== 'OS') {
    return false;
  }

  // Braze appends ?abDeepLink=true to some links. We don't want the abDeepLink part
  // for example: /OS/review?abDeepLink=true
  const [sanitizedAction] = maybeAction.split('?');

  switch (sanitizedAction) {
    case OsPrompts.push: {
      enablePush().then(response => {
        if (!logRBIEvent || !response) {
          return;
        }

        logRBIEvent({
          name: 'Push Notifications Response',
          type: EventTypes.Other,
          attributes: {
            response: response.status,
          },
        });
      });

      break;
    }

    case OsPrompts.location: {
      enableLocation()
        .then()
        .catch(err => {
          logger.warn(`location: enableLocation error: ${err}`);
        });

      break;
    }

    case OsPrompts.review: {
      promptReview().then(() => {
        if (logRBIEvent) {
          logRBIEvent({
            name: 'App Review Pop Up',
            type: EventTypes.Other,
            attributes: {},
          });
        }
      });

      break;
    }

    case OsPrompts.att: {
      if (Platform.OS === 'ios') {
        appTrackingTransparency().catch(() => {
          logger.warn(`Error in requesting user authorization for App Tracking Transparency`);
        });
      }

      break;
    }

    case OsPrompts.pushSetting: {
      openPushSetting();
      break;
    }

    default: {
      logger.warn(`location: unknown OS/ link: ${url}`);
      break;
    }
  }

  return true;
};
